import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import exact from 'prop-types-exact'
import { Link } from 'react-router'
import { pure } from 'recompose'
import { ARTIST_PORTAL_ROUTE, LEARNING_HUB_ROUTE } from 'config'
import teachingArtistPortal from 'images/communities/Chicago/Educator/school-portal.png'
import learningHubPortal from 'images/communities/Chicago/learning-hub/learning-hub.svg'
import classnames from 'classnames'

const propTypes = {
  currentPortal: Types.portalType.isRequired,
  learningHubAccess: PropTypes.bool,
}

const defaultProps = {
  learningHubAccess: false,
}

function TeachingArtistPortalSelector({ currentPortal, learningHubAccess }) {
  return (
    <nav className="portal-select" aria-label="Portal select">
      <ul>
        <li>
          <Link
            to={ARTIST_PORTAL_ROUTE}
            className={classnames({
              'selected-portal': currentPortal === Types.PORTAL.ARTIST_PORTAL,
            })}
          >
            <img src={teachingArtistPortal} alt="" />
            Teaching Artist
          </Link>
        </li>
        {learningHubAccess && (
          <li>
            <Link
              to={LEARNING_HUB_ROUTE}
              className={classnames({
                'selected-portal': currentPortal === Types.PORTAL.LEARNING_HUB,
              })}
            >
              <img src={learningHubPortal} alt="" />
              Learning Hub
            </Link>
          </li>
        )}
      </ul>
    </nav>
  )
}

TeachingArtistPortalSelector.propTypes = exact(propTypes)
TeachingArtistPortalSelector.defaultProps = defaultProps

export default pure(TeachingArtistPortalSelector)
